import { jsx as _jsx } from "react/jsx-runtime";
export const DocumentS = ({ color, ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.5 2.25C14.6989 2.25 14.8896 2.32908 15.0303 2.46973L19.5303 6.96973C19.668 7.10547 19.75 7.28911 19.75 7.5V20C19.75 20.9665 18.9665 21.75 18 21.75H6C5.0335 21.75 4.25 20.9665 4.25 20V4C4.25001 3.03351 5.03351 2.25 6 2.25H14.5ZM6 3.75C5.86193 3.75 5.75001 3.86193 5.75 4V20C5.75 20.1381 5.86193 20.25 6 20.25H18C18.1381 20.25 18.25 20.1381 18.25 20V8.25H14.5C14.0858 8.25 13.75 7.91421 13.75 7.5V3.75H6ZM15 15.75C15.4142 15.75 15.75 16.0858 15.75 16.5C15.75 16.9142 15.4142 17.25 15 17.25H8C7.58579 17.25 7.25 16.9142 7.25 16.5C7.25 16.0858 7.58579 15.75 8 15.75H15ZM15 11.75C15.4142 11.75 15.75 12.0858 15.75 12.5C15.75 12.9142 15.4142 13.25 15 13.25H8C7.58579 13.25 7.25 12.9142 7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75H15Z",
            fill: color ?? 'currentColor'
        })
    });

//# sourceMappingURL=document-s.js.map